// extracted by mini-css-extract-plugin
export default {"root":"root---udUnV","label":"label---DC5A5"};